import { generateUtilityClasses } from "@mui/material";
const toolbarButtonName = "TidalToolbarButton";
const toolbarButtonClasses = generateUtilityClasses(
  toolbarButtonName,
  ["badge", "hoverBulge", "icon", "indicator", "label", "labelOff", "labelOn", "root", "selected", "tooltip"]
);
export {
  toolbarButtonClasses,
  toolbarButtonName
};
//# sourceMappingURL=classes.js.map
